const setError = (condition, field, message, errorForm) => {
  if (condition) {
    errorForm[field] = message
  } else if (!errorForm.hasOwnProperty(field)) {
    errorForm[field] = ''
  }
}

export const validateForm = form => {
  const errorForm = {}

  const fieldsToValidate = [
    {
      condition: !form.subject,
      field: 'subject',
      message: 'Заполните тему'
    },
    {
      condition: !form.description,
      field: 'description',
      message: 'Заполните описание'
    }
  ]

  fieldsToValidate.forEach(({ condition, field, message }) =>
    setError(condition, field, message, errorForm)
  )

  return errorForm
}
